import React, { useEffect, useRef, useState } from "react"
import { Link, useNavigate,useParams } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import img2 from "../../Login/img/logo.png"
import './style.css'
import { connect } from "react-redux";
import { setApiToken, setUserInfo } from "../../actions/userActions";

const Sidebar = (props) => {
  const navigate = useNavigate()
  const id = useParams()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (props.apiToken == "") {
      if (localStorage.getItem('access_token') == null) {
        navigate('/')
      } else {
        props.setUserInfo(JSON.parse(localStorage.getItem('user_data')))
        props.setApiToken(localStorage.getItem('access_token'))
      }
    }
  }, [props])

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeToggle = () =>{
    setIsSidebarOpen(!isSidebarOpen)
  }
  return (
    <>
      {/* <SimpleBar style={{ maxHeight: 200 }} forceVisible="y" autoHide={false} ref={ref}> */}

      <div className="sidebar d-none d-sm-block">
        <img src={img2} className="side-logo" />
        <hr className="hr-side" />

        <div className={window.location.pathname == "/upload" ? "side-tab" : "side-tab-plain"}>
          <Link to="/upload">

            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-cloud-upload-alt"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  Upload
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/dashboard" ? "side-tab" : "side-tab-plain"}>
          <Link to="/dashboard">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-tv"></i>
                </div>

              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  View
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/archived" ? "side-tab" : "side-tab-plain"}>
          <Link to="/archived">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-archive"></i>
                </div>

              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  Archived
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/grouped" ? "side-tab" : "side-tab-plain"}>
          <Link to="/grouped">

            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-layer-group"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  Grouped
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/sou" ? "side-tab" : "side-tab-plain"}>
          <Link to="/sou">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  SOU
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/create-class" ? "side-tab" : "side-tab-plain"}>
          <Link to="/create-class">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text" style={{ fontSize: '14px' }}>
                  Create Class
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/class-created" ? "side-tab" : "side-tab-plain"}>
          <Link to="/class-created">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text">
                  Classes Creation
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        
        <div className={window.location.pathname == "/view-class" ? "side-tab" : "side-tab-plain"}>
          <Link to="/view-class">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text" >
                  View Class
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/training" ? "side-tab" : "side-tab-plain"}>
          <Link to="/training">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text" >
                  Training
                </div>
              </Col>
            </Row>
          </Link>
        </div>
        <div className={window.location.pathname == "/holiday" ? "side-tab" : "side-tab-plain"}>
          <Link to="/holiday">
            <Row>
              <Col md={2}>
                <div className="side-icon">
                  <i class="fas fa-eye"></i>
                </div>
              </Col>
              <Col md={10}>
                <div className="side-tab-text" >
                  Holiday
                </div>
              </Col>
            </Row>
          </Link>
        </div>

      </div>
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfo: (apiToken) => dispatch(setUserInfo(apiToken)),
    setApiToken: (apiToken) => dispatch(setApiToken(apiToken)),
  };
};
const mapStateToProps = (state) => {
  return {
    userdata: state.userInfo,
    apiToken: state.apiToken
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
